import {gql} from '@apollo/client'

export const START_HEALTHCARE = gql`
  mutation startHealthcare {
    startHealthcare(input: {}) {
      status
      link
    }
  }
`

export interface StartHealthcareQueryResult {
  startHealthcare: {
    status: 'started' | 'not_started'
    link: string | null
  }
}

export const REGISTER_HEALTHCARE = gql`
  mutation registerHealthcare($input: RegisterHealthcareInput!) {
    registerHealthcare(input: $input) {
      status
      link
    }
  }
`

export interface RegisterHealthcareQueryVariables {
  input: {
    stressCheck?: boolean
    stressCheckRole?: string
    regularHealthCheckup?: boolean
  }
}

export interface RegisterHealthcareQueryResult {
  registerHealthcare: {
    status: 'started' | 'not_started'
    link: string | null
  }
}
